import axios from "@/plugins/axios";

let url = (data) => "/api/console/users/${_user}/files".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url(data)}/${data._id}`).then((result) => result.data);
    },
    post({ _user, type }, file) {
        var formData = new FormData();

        if (type) formData.append("type", type);
        formData.append("file", file);

        var headers = { "Content-Type": "multipart/form-data" };

        return axios.post(`${url({ _user })}`, formData, { headers }).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url(data)}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url(data)}/${data._id}`).then((result) => result.data);
    },
};
